import React, { PropTypes, Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { Utils } from "react-stockcharts";
import { getStartAndEndDateForPeriod } from "utils";


import SecuritySearchSelector from "./SecuritySearchSelector";
import ChartTypeSelector from "./ChartTypeSelector";
import Indicators from "./Indicators";
import InteractiveIndicator from "./InteractiveIndicator";
import ChartSettings from "./ChartSettings";
import ChartWidget from "./ChartWidget";
import SettingsModal from "./SettingsModal";
import PeriodShortcut from "./PeriodShortcut";
import BlockingModal from "./BlockingModal";
import EscHandler from "components/misc/EscHandler";

import * as ChartPageActions from "actions/ChartPageActions";

const DATE_ACCESSOR = d => d.date;

class ChartComponent extends Component {
	constructor(props) {
		super(props);
		this.handleIndicatorSettingsChange = this.handleIndicatorSettingsChange.bind(this);
		this.handleChartSettingsChange = this.handleChartSettingsChange.bind(this);
		this.resetPeriodShortcut = this.resetPeriodShortcut.bind(this);
		// this.getDimensions = this.getDimensions.bind(this);
	}
	handleSecuritySelect(exchange, security) {
		var { actions } = this.props;
		// actions.securitySearch(this.props.index, query)
		console.log(exchange, security);
	}
	shouldComponentUpdate(nextProps) {
		var updateComponent = true;
		if (!this.props.resized && nextProps.resized) updateComponent = false;
		return updateComponent;
	}
	componentWillMount() {
		var { data, actions, index, securitySelector } = this.props;
		var { security, exchange } = securitySelector;
		if (!data) actions.loadData(index, security, exchange);
	}
	componentWillUpdate() {
		var { data, actions, index, securitySelector } = this.props;
		var { security, exchange } = securitySelector;
		// if (!data) actions.loadData(index, security, exchange);
	}
	componentDidUpdate() {
		var { activePeriod } = this.props;
		var { widget } = this.refs;
		if (widget) {
			if (activePeriod) {
				var dataInfo = widget.getDataInfo();
				var { xAccessor, data } = dataInfo;
				var range = getStartAndEndDateForPeriod(activePeriod, dataInfo);
				// console.log(range);
				var start = Utils.getClosestItem(data, range.start, DATE_ACCESSOR);
				var end = Utils.getClosestItem(data, range.end, DATE_ACCESSOR);
				// console.log(start, end);
				widget.setViewRange(xAccessor(start), xAccessor(end));
			}
		}
	}
	handleChartSettingsChange(chartType, options) {
		var { actions, index } = this.props;
		// console.log(chartType, options);
		actions.showChartSettings(index, options);
	}
	handleIndicatorSettingsChange(reference, options) {
		var { actions, index } = this.props;
		actions.showChartIndicatorSettings(index, reference, options);
	}
	resetPeriodShortcut() {
		var { actions, index, activePeriod } = this.props;
		if (activePeriod) actions.setViewPeriod(index, null);
	}
	render() {
		var { demo : { complete: demoComplete } } = this.props;

		var {
			securitySelector,
			chartSelector,
			indicators,
			interactiveIndicator,
			chartSettings,
			showSettings,
			settings,
			settingsType,
			activePeriod,
			actions,
			index,
			width,
			height,
			resized,
			data,
			activePeriod
		} = this.props;

		var {
			exchangeSelectDropDownToggle,
			exchangeSelect,
			securityFocus,
			securitySearch,
			chartTypeSelectDropDownToggle,
			chartTypeSelect,
			indicatorsDropDownToggle,
			interactiveIndicatorDropDownToggle,
			addIndicator,
			setInteractiveIndicator,
			removeIndicator,
			updateChartIndicatorSettings,
			showChartSettings,
			closeChartIndicatorSettings,
			settingsDropDownToggle,
			changeSettings,
			changeChartSettings,
			setViewPeriod,
			// unSetViewPeriod,
		} = actions;

		var widget = !data
			? <div>Loading...</div>
			: <ChartWidget
				ref="widget"
				width={width} height={height}
				data={data}
				demoComplete={demoComplete}
				indicators={indicators.list}
				interactiveIndicator={interactiveIndicator.type}
				type={chartSelector.chartType}
				transforms={chartSelector.transforms}
				settings={chartSelector.options}
				exchange={securitySelector.exchange}
				security={securitySelector.securityDisplay}
				grid={chartSettings.settings.showGrid}
				onIndicatorSettingsChange={this.handleIndicatorSettingsChange}
				onChartSettingsChange={this.handleChartSettingsChange} 
				onZoom={this.resetPeriodShortcut}
				onPan={this.resetPeriodShortcut} />;


		var settingsModal = showSettings
			? <SettingsModal title="Change Settings"
				settingsType={settingsType} chartType={chartSelector.chartType}
				onSubmit={updateChartIndicatorSettings.bind(null, index)}
				onChartSettingsChange={changeChartSettings.bind(null, index, chartSelector.chartType)}
				onDestroy={removeIndicator.bind(null, index, settings)}
				onClose={closeChartIndicatorSettings.bind(null, index)}
				options={settings} />
			: null;
		return (
			<div className={this.props.layout + " chart-component"}>
				<EscHandler enabled={securitySelector.showExchangeSelectorDropDown
						|| securitySelector.focus
						|| chartSelector.showDropDown
						|| indicators.showDropDown
						|| interactiveIndicator.showDropDown
						|| chartSettings.showDropDown} {...this.props.pageActions}>
					{/* <SecuritySearchSelector {...securitySelector}
						onDropDownToggle={exchangeSelectDropDownToggle.bind(null, index, !securitySelector.showExchangeSelectorDropDown)}
						onExchangeSelect={exchangeSelect.bind(null, index)}
						onSecurityFocus={securityFocus.bind(null, index)}
						onSecuritySearch={securitySearch.bind(null, index)} 
						onSecuritySelect={this.handleSecuritySelect} /> */ }
					<ChartTypeSelector {...chartSelector}
						onDropDownToggle={chartTypeSelectDropDownToggle.bind(null, index, !chartSelector.showDropDown)}
						onChartTypeSelect={chartTypeSelect.bind(null, index)} /> 
					<Indicators {...indicators}
						onDropDownToggle={indicatorsDropDownToggle.bind(null, index, !indicators.showDropDown)}
						onIndicatorAdd={addIndicator.bind(null, index)} />
					<InteractiveIndicator {...interactiveIndicator}
						onDropDownToggle={interactiveIndicatorDropDownToggle.bind(null, index, !interactiveIndicator.showDropDown)}
						setInteractiveIndicator={setInteractiveIndicator.bind(null, index)} />
					<ChartSettings {...chartSettings}
						onDropDownToggle={settingsDropDownToggle.bind(null, index, !chartSettings.showDropDown)} 
						onChangeSettings={changeSettings.bind(null, index)} />
					<PeriodShortcut activePeriod={activePeriod} onSetViewPeriod={setViewPeriod.bind(null, index)} />
				</EscHandler>
				<div className="chart-widget">
					{widget}
				</div>
				{ settingsModal }
				{ !demoComplete ? <BlockingModal /> : null }
			</div>
		);
	}
}

ChartComponent.propTypes = {
	index: PropTypes.number.isRequired,
	securitySelector: PropTypes.object.isRequired,
	chartSelector: PropTypes.object.isRequired,
	indicators: PropTypes.object.isRequired,
	chartSettings: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
	return { actions: bindActionCreators(ChartPageActions, dispatch) };
}

export default connect(state => state, mapDispatchToProps)(ChartComponent);


/** WEBPACK FOOTER **
 ** ./src/scripts/components/page/ChartPage/ChartComponent.jsx
 **/